export default {
  tab: {
    _3_months: '3 Tháng',
    _6_months: '6 Tháng',
    _9_months: '9 Tháng',
    this_year: '1 Năm',
    year_to_date: 'Từ đầu năm',
  },
  valueProprotion: 'Tỷ trọng giá trị khớp lệnh (%)',
  tooltip: {
    fmiAbs: 'FMI Abs',
    fmiRel: 'FMI Rel',
  },
  fmi: 'FMI 5',
  closeIndex: 'Chỉ số giá',
  rightLabelAbs: 'FMI (Abs) - Tỷ VND',
  rightLabelRel: 'FMI (Rel) - Tỷ VND',
  chartTitleAbsolute: 'FIINTRADE MONEY FLOW INDEX ABSOLUTE (FMI ABS)',
  chartTitleRelative: 'FIINTRADE MONEY FLOW INDEX RELATIVE (FMI REL)',
  legendFmiAbs: 'FMI Abs',
  legendFmiRel: 'FMI Rel',
  footer: `Tham khảo cách sử dụng
  <a target="_blank" rel="noreferrer noopener" href="%{url}">tại đây</a> 
  (Lưu ý dữ liệu FMI được cập nhật cuối ngày)
 `,
};
